import { DefaultValue } from "recoil";
import { api } from "@/comn";
import { colUtils } from "@/tz/go/egaz/osci/colt/comn"; // 시스템 공통 유틸
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { format } from "path";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${lpcoEnvs.base}/lpco/fee`,
    api_v1: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/fee`,
    selectAppInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-info`, // Application Information
    app_api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new`,
    reus_api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/colt/reus`,
    nodes: [
        { path: "/", label: "L_ESW" },
        { path: "/fee", label: "L_LPCO_FEE" },
    ],
};

export const URLS = {
    osci0205001q: `${BASE.path}/osci0205001q`, // List View billing history information !== 고지 내역 정보 목록 화면 ==!
    osci0205002s: `${BASE.path}/osci0205002s`, // Details View billing history information !== 고지 내역 정보 상세 화면 ==!
    osci0205003q: `${BASE.path}/osci0205003q`, // List About your unpaid history !== 미납 내역 정보 목록 화면 ==!
    osci0205004s: `${BASE.path}/osci0205004s`, // Details About your unpaid history !== 미납 내역 정보 상세 화면 ==!
    osci0205005q: `${BASE.path}/osci0205005q`, // List Payment history information !== 납부 내역 정보 목록 화면 ==!
    osci0205006s: `${BASE.path}/osci0205006s`, // Details Payment history information !== 납부 내역 정보 상세 화면 ==!
    osci0205007q: `${BASE.path}/osci0205007q`,
    osci0205008s: `${BASE.path}/osci0205008s`,
    osci0201012q: `${BASE.path}/new/osci0201012q`, // Application List(Approval) !== 신청서 목록(Approval) ==!
    osci0201014s: `${BASE.path}/new/osci0201014s`, // Application Detail(Approval) !== 신청서 상세(Approval) ==!
    osci0205009q: `${BASE.path}/osci0205009q`,
    osci0205010q: `${BASE.path}/osci0205010q`,
    osci0205011s: `${BASE.path}/osci0205011s`,
    osci0202002q: `${lpcoEnvs.base}/lpco/tansad/osci0202002q`, // TANSAD정보 조회 팝업
    osci0401003q: `/osci/colt/ntfc/osci0401003q`, // TANSAD Bill List !== TANSAD 고지 목록 ==!
};

export const APIS = {
    // Get list of notification details !== 수수료 내역 목록 조회 ==!
    getLpcoFeeList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api_v1}?page=${page}&size=${size}`, {
            params: data,
        });
    },
    // Get notification details in detail !== 수수료 내역 상세 조회 ==!
    getLpcoFeeDtl: (feeId: any) => {
        return api.get(`${BASE.api_v1}/${feeId}`);
    },
    // Get fee id by application no !== 신청번호로 수수료 ID 조회 ==!
    getFeeIdToAppNo: (appNo: any, appDgr: any) => {
        return api.get(`${BASE.api_v1}/fee-id/${appNo}/${appDgr}`);
    },
    // Get Application Information !== 신청서 정보 조회 ==!
    getAppInfo: (data: any) => {
        return api.get(`${BASE.api_v1}/app-info/${data.feeId}/${data.orgCd}`, {
            // params: data,
        });
    },
    saveFee: (data: any) => {
        return api.post(`${BASE.api_v1}/feeSave`, {
            ...data,
        });
    },
    confirmFee: (data: any) => {
        return api.post(`${BASE.api_v1}/feeConfirm`, {
            ...data,
        });
    },
    issBll: (data: any) => {
        return api.post(`${BASE.api_v1}/issBll`, {
            ...data,
        });
    },
    returnFee: (data: any) => {
        return api.post(`${BASE.api_v1}/feeReturn`, {
            ...data,
        });
    },
    reusBll: (data: any) => {
        return api.post(`${BASE.api_v1}/reusBll`, {
            ...data,
        });
    },
    testIssNmlBll: (data: any) => {
        console.log("call>> testIssNmlBll");
        return api.post(`${BASE.api_v1}/testIssNmlBll`, {
            ...data,
        });
    },
    testIssCbnBll: (data: any) => {
        console.log("call>> testIssCbnBll");
        return api.post(`${BASE.api_v1}/testIssCbnBll`, {
            ...data,
        });
    },
    getExchageRate: (usd: any) => {
        console.log(`[APIS::getExchageRate] =======================`);
        return api.get(`${BASE.api_v1}/exrt`, {
            params: {},
        });
    },
    // Get Fee Modification Request List !== 수수료 변경 신청 목록 조회 (OSCI_LPCO_FEE_MDFY_R 기준) ==!
    getFeeUpdateList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api_v1}/updtList?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get Bill Info !== 고지 정보 조회 ==!
    getBllDtlInfo: (id: any) => {
        return api.get(`${BASE.reus_api}/${id}/lpcoBll`);
    },
    // Get Fee Modification Request Detail !== 수수료 변경 신청 상세 조회 (OSCI_LPCO_FEE_MDFY_R 기준) ==!
    getBllUpdtDtl: (data: any) => {
        return api.get(`${BASE.api_v1}/updtDtl`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Delete Fee Modification Request !== 수수료 변경 신청 내역 삭제 (OSCI_LPCO_FEE_MDFY_R) ==!
    deleteLpcoFeeMdfy: (feeId: any, mdfyRqstSn?: any) => {
        return api.delete(`${BASE.api_v1}/mdfyDelete/${feeId}`, { params: { mdfyRqstSn } });
    },
    // Save Fee Modification Request !== 수수료 변경 신청 저장 (OSCI_LPCO_FEE_MDFY_R/ITM_R) ==!
    saveLpcoFeeMdfy: (dtlData: any, mdfyData: any, mode: any) => {
        return api.post(`${BASE.api_v1}/mdfySave/${mode}`, {
            ...dtlData,
            ...mdfyData,
        });
    },
    adjustFee: (data: any) => {
        return api.post(`${BASE.api_v1}/feeAdjust`, {
            ...data,
        });
    },
    // Get Fee Change History List
    getLpcoFeeHistList: (feeId: any) => {
        return api.get(`${BASE.api_v1}/hist-list/${feeId}`);
    },
};

export const SF_SCHEMA_SEARCH_FORM: TFormSchema = {
    id: "form_search",
    schema: {
        bllNo: {
            type: "text",
            label: "L_OGA_BLL_NO",
            edit: true,
        },
        appNo: {
            type: "text",
            label: "L_APP_NO",
            edit: true,
        } /* Application No !== 신청서 번호 ==!*/,
        ucrNo: {
            type: "text",
            label: "L_UCR_NO",
            edit: true,
            letterCase: "upper",
        } /* UCR No !== UCR 번호 ==!*/,
        feeImpsTpCd: {
            type: "text",
            label: "L_FEE_TP",
            edit: true,
        } /* Fee Type !== 수수료 유형 ==! */,
        payCurrCd: {
            type: "text",
            label: "L_CURR",
            edit: true,
        } /* Currency !== 통화 ==! */,
        payAmt: {
            type: "text",
            label: "L_PAID_AMT",
            edit: true,
        } /* Paid Amount !== 납부금액 ==! */,
        bllAmt: {
            type: "text",
            label: "L_BLL_AMT",
            edit: true,
        } /* Paid Amount !== 고지서금액 ==! */,
        issDt: {
            type: "daterange",
            label: "L_BLL_ISS_DT1",
            edit: true,
            start: { name: "bllIssDtStr" },
            end: { name: "bllIssDtEnd" },
        } /* Approval Date !== 고지서 발급 일자 ==! */,
        xpirDt: {
            type: "daterange",
            label: "L_XPIR_DT_1",
            edit: true,
            start: { name: "dueDtStr" },
            end: { name: "dueDtEnd" },
        } /* Expiry Date !== 만료 일자 ==! */,
        payDt: {
            type: "daterange",
            label: "L_PAY_DT",
            edit: true,
            start: { name: "payDtStr" },
            end: { name: "payDtEnd" },
        } /* Payment Date !== 결제 날짜 ==! */,
        feePrcssStatCd: {
            type: "select",
            label: "L_PRCSS_STAT",
            area: "comnCd",
            comnCd: "OSC0122",
            edit: true,
            all: true,
        } /* Processing Status !== 처리 상태 ==! */,
        rmrk: {
            type: "text",
            label: "L_RMK",
            edit: true,
        } /* Description !== 설명 ==! */,
    },
};

export const SF_SCHEMA_LPCO_FEE_FORM: TFormSchema = {
    id: "form_lpcoFee",
    schema: {
        bllNo: {
            type: "text",
            label: "L_OGA_BLL_NO",
            edit: true,
        },
        bllMgmtId: {
            type: "text",
            label: "L_BLL_MGMT_ID",
            edit: true,
        },
        appNo: {
            type: "text",
            label: "L_APP_NO",
            edit: true,
        } /* Application No !== 신청서 번호 ==!*/,
        feeImpsTpCd: {
            type: "select",
            label: "L_FEE_IMPS",
            area: "comnCd",
            comnCd: "OSC0123",
            edit: false,
        } /* Fee Impose Type Code	!== 수수료 부과 유형 코드 ==! */,
        currCd: {
            type: "text",
            label: "L_CURR",
            edit: true,
        } /* Currency !== 통화 ==! */,
        paidAmt: {
            type: "number",
            label: "L_PAID_AMT",
            edit: true,
            thousandSeparator: true,
        } /* Paid Amount !== 납부금액 ==! */,
        bllAmt: {
            type: "number",
            label: "L_FEE_AMT",
            edit: true,
            thousandSeparator: true,
        } /* Paid Amount !== 고지서금액 ==! */,
        bllTzsAmt: {
            type: "number",
            label: "L_FEE_AMT_TZS",
            edit: true,
            thousandSeparator: true,
        } /* Paid Amount !== 고지서금액 ==! */,
        issDt: {
            type: "date",
            label: "L_BLL_ISS_DT1",
            edit: true,
        } /* Approval Date !== 고지서 발급 일자 ==! */,
        xpirDt: {
            type: "date",
            label: "L_XPIR_DT_1",
            edit: true,
        } /* Expiry Date !== 만료 일자 ==! */,
        payDt: {
            type: "date",
            label: "L_PAY_DT",
            edit: true,
        } /* Payment Date !== 결제 날짜 ==! */,
        bllSttsCd: {
            type: "select",
            label: "L_PRCSS_STAT",
            area: "comnCd",
            comnCd: "OSC0122",
            edit: true,
        } /* Processing Status !== 처리 상태 ==! */,
        rmrk: {
            type: "textarea",
            label: "L_RMK",
            edit: false,
            rows: 5,
        } /* Description !== 설명 ==! */,
        appNm: {
            type: "text",
            label: "L_APP",
        },
        ctrlNo: {
            type: "text",
            label: "L_CTRL_NO",
        },
    },
};

export const SG_GRID_LPCO_FEE_NTCE_LIST: TGridSchema = {
    id: "grid_notice",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, height: "auto" },
    head: [
        {
            cells: [
                { header: "L_APP_NO", binding: "appNo", width: "2*" },
                { header: "L_UCR_NO", binding: "ucrNo" },
            ],
            id: "appNo",
        },
        { cells: [{ header: "L_TANSAD_NO", binding: "tansadNo", width: "*", rowspan: 2 }], id: "tansadNo" },
        {
            cells: [
                { header: "L_OGA_BLL_NO", binding: "bllNo", width: 210 },
                { header: "L_CTRL_NO", binding: "ctrlNo" },
            ],
            id: "bllNo",
        },
        {
            cells: [
                { header: "L_ISS_DT", binding: "bllIssDt", width: "*" },
                { header: "L_PAY_DT", binding: "feePayDtm" },
            ],
            id: "bllIssDt",
        },
        {
            cells: [
                { header: "L_FEE_AMT_TZS", binding: "bllTzsAmt", width: "*" },
                { header: "L_NTC_TP", binding: "ntcTp", width: "*" },
            ],
            id: "bllTzsAmt",
        },
        {
            cells: [{ header: "L_PRCSS_STAT", binding: "feePrcssStatCd", width: 210, rowspan: 2 }],
            id: "feePrcssStatCd",
        },
    ],
    body: [
        {
            cells: [
                { binding: "appNo", type: "text", align: "left" },
                { binding: "ucrNo", type: "text", align: "left" },
            ],
        },
        {
            cells: [{ binding: "tansadNo", mask: colUtils.getMaskPattern("tansadNo"), rowspan: 2 }],
        },
        {
            cells: [
                { binding: "bllNo", type: "text" },
                { binding: "ctrlNo", type: "text" },
            ],
        },
        {
            cells: [
                { binding: "bllIssDt", type: "date" },
                { binding: "feePayDtm", type: "date" },
            ],
        },
        {
            cells: [
                { binding: "bllTzsAmt", type: "number", thousandSeparator: true, align: "right" },
                { binding: "ntcTp", type: "text" },
            ],
        },
        {
            cells: [
                { binding: "feePrcssStatCd", type: "select", area: "comnCd", comnCd: "OSC0122", rowspan: 2 },
            ] /* Processing Status !== 처리 상태 ==! */,
        },
    ],
};

export const SG_GRID_LPCO_FEE_UPID_LIST: TGridSchema = {
    id: "grid_unpaid",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, height: "auto" },
    head: [
        {
            cells: [
                { header: "L_APP_NO", binding: "appNo", width: "2*" },
                { header: "L_UCR_NO", binding: "ucrNo" },
            ],
            id: "appNo",
        },
        { cells: [{ header: "L_TANSAD_NO", binding: "tansadNo", width: "*", rowspan: 2 }], id: "tansadNo" },
        {
            cells: [
                { header: "L_OGA_BLL_NO", binding: "bllNo", width: 210 },
                { header: "L_CTRL_NO", binding: "ctrlNo" },
            ],
            id: "bllNo",
        },
        {
            cells: [
                { header: "L_ISS_DT", binding: "bllIssDt", width: "*" },
                { header: "L_XPIR_DT_1", binding: "bllXpirDt" },
            ],
            id: "bllIssDt",
        },
        {
            cells: [
                { header: "L_FEE_AMT_TZS", binding: "bllTzsAmt", width: "*" },
                { header: "L_NTC_TP", binding: "ntcTp", width: "*" },
            ],
            id: "bllTzsAmt",
        },
        {
            cells: [{ header: "L_PRCSS_STAT", binding: "feePrcssStatCd", width: 210, rowspan: 2 }],
            id: "feePrcssStatCd",
        },
    ],
    body: [
        {
            cells: [
                { binding: "appNo", type: "text", align: "left" },
                { binding: "ucrNo", type: "text", align: "left" },
            ],
        },
        {
            cells: [{ binding: "tansadNo", mask: colUtils.getMaskPattern("tansadNo"), rowspan: 2 }],
        },
        {
            cells: [
                { binding: "bllNo", type: "text" },
                { binding: "ctrlNo", type: "text" },
            ],
        },
        {
            cells: [
                { binding: "bllIssDt", type: "date" },
                { binding: "bllXpirDt", type: "date" },
            ],
        },
        {
            cells: [
                { binding: "bllTzsAmt", type: "number", thousandSeparator: true, align: "right" },
                { binding: "ntcTp", type: "text" },
            ],
        },
        {
            cells: [
                { binding: "feePrcssStatCd", type: "select", area: "comnCd", comnCd: "OSC0122", rowspan: 2 },
            ] /* Processing Status !== 처리 상태 ==! */,
        },
    ],
};

export const SG_GRID_LPCO_FEE_PAID_LIST: TGridSchema = {
    id: "grid_paid",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, height: "auto" },
    head: [
        {
            cells: [
                { header: "L_APP_NO", binding: "appNo", width: "2*" },
                { header: "L_UCR_NO", binding: "ucrNo" },
            ],
            id: "appNo",
        },
        { cells: [{ header: "L_TANSAD_NO", binding: "tansadNo", width: "*", rowspan: 2 }], id: "tansadNo" },
        {
            cells: [
                { header: "L_OGA_BLL_NO", binding: "bllNo", width: 210 },
                { header: "L_CTRL_NO", binding: "ctrlNo" },
            ],
            id: "bllNo",
        },
        {
            cells: [
                { header: "L_ISS_DT", binding: "bllIssDt", width: "*" },
                { header: "L_PAY_DT", binding: "feePayDtm" },
            ],
            id: "bllIssDt",
        },
        {
            cells: [
                { header: "L_FEE_AMT_TZS", binding: "bllTzsAmt", width: "*" },
                { header: "L_NTC_TP", binding: "ntcTp", width: "*" },
            ],
            id: "bllTzsAmt",
        },
        {
            cells: [{ header: "L_PRCSS_STAT", binding: "feePrcssStatCd", width: 210, rowspan: 2 }],
            id: "feePrcssStatCd",
        },
    ],
    body: [
        {
            cells: [
                { binding: "appNo", type: "text", align: "left" },
                { binding: "ucrNo", type: "text", align: "left" },
            ],
        },
        {
            cells: [{ binding: "tansadNo", mask: colUtils.getMaskPattern("tansadNo"), rowspan: 2 }],
        },
        {
            cells: [
                { binding: "bllNo", type: "text" },
                { binding: "ctrlNo", type: "text" },
            ],
        },
        {
            cells: [
                { binding: "bllIssDt", type: "date" },
                { binding: "feePayDtm", type: "date" },
            ],
        },
        {
            cells: [
                { binding: "bllTzsAmt", type: "number", thousandSeparator: true, align: "right" },
                { binding: "ntcTp", type: "text" },
            ],
        },
        {
            cells: [
                { binding: "feePrcssStatCd", type: "select", area: "comnCd", comnCd: "OSC0122", rowspan: 2 },
            ] /* Processing Status !== 처리 상태 ==! */,
        },
    ],
};

export const SF_FEE_RGST_SEARCH_FORM: TFormSchema = {
    id: "form_search",
    schema: {
        srchAppNo: { type: "text", label: "L_APP_NO", edit: true } /* Application No !== 신청번호 ==!*/,
        srchUcrNo: { type: "text", label: "L_UCR_NO", edit: true } /* UCR No !== UCR번호 ==!*/,
        frstRgsrDt: {
            type: "daterange",
            label: "L_RGSR_DT",
            edit: true,
            start: { name: "frstRgsrDtStr" },
            end: { name: "frstRgsrDtEnd" },
        },
        feePrcssStatCds: {
            type: "checkbox",
            label: "L_PRCSS_STAT",
            area: "comnCd",
            comnCd: "OSC0122",
            all: true,
            excludes: ["PG", "PC", "PP", "PE", "BC"],
            controlSize: 10,
            required: true,
        } /* Processing Status !== 처리 상태 ==! */,
    },
};

export const SG_GRID_LPCO_FEE_RGST_LIST: TGridSchema = {
    id: "grid_paid",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, height: "auto" },
    head: [
        {
            cells: [
                { header: "L_APP_NO", binding: "appNo", width: "2*" },
                { header: "L_UCR_NO", binding: "ucrNo" },
            ],
            id: "appNo",
        },
        { cells: [{ header: "L_TANSAD_NO", binding: "tansadNo", width: "*", rowspan: 2 }], id: "tansadNo" },
        { cells: [{ header: "L_CURR_CD", binding: "currCd", width: "*", rowspan: 2 }] },
        {
            cells: [
                { header: "L_FEE_AMT", binding: "bllAmt", width: "*" },
                { header: "L_FEE_AMT_TZS", binding: "bllTzsAmt" },
            ],
            id: "bllTzsAmt",
        },
        {
            cells: [
                { header: "L_BLL_TP", binding: "cmbiBllYn", width: "*" },
                { header: "L_RGSR_DT", binding: "frstRgsrDtm", width: "*" },
            ],
            id: "cmbiBllYn",
        },

        {
            cells: [
                { header: "L_PRCSS_STAT", binding: "feePrcssStatCd", width: 210 },
                { header: "L_RMRK", binding: "rmrk" },
            ],
            id: "feePrcssStatCd",
        },
    ],
    body: [
        {
            cells: [
                { binding: "appNo", type: "text", align: "left" },
                { binding: "ucrNo", type: "text", align: "left" },
            ],
        },
        {
            cells: [{ binding: "tansadNo", mask: colUtils.getMaskPattern("tansadNo"), rowspan: 2 }],
        },
        { cells: [{ binding: "currCd", rowspan: 2 }] },
        {
            cells: [
                { binding: "bllAmt", type: "number", thousandSeparator: true, align: "right" },
                { binding: "bllTzsAmt", type: "number", thousandSeparator: true, align: "right" },
            ],
        },
        {
            cells: [
                { binding: "cmbiBllYn" },
                { binding: "frstRgsrDtm", type: "date" },
            ] /* Approval Date !== 승인 일자 ==! */,
        },
        {
            cells: [
                { binding: "feePrcssStatCd", type: "select", area: "comnCd", comnCd: "OSC0122" },
                { binding: "rmrk", align: "left" },
            ],
        },
    ],
};

export const SF_FEE_RGSR_DTL: TFormSchema = {
    id: "form_aprvapp_dtl",
    schema: {
        appId: { type: "text", edit: false } /* Application Universally Unique Identifier !== 신청서_UUID ==!*/,
        amdTpCd: { type: "text", edit: false } /* Amenment Type Code !== 정정유형코드 ==!*/,
        appNo: { type: "text", label: "L_APP_NO", edit: false } /* Application No !== 신청번호 ==!*/,
        ucrNo: { type: "text", label: "L_UCR_NO", edit: false } /* UCR No !== UCR번호 ==!*/,
        orgCd: {
            type: "text",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA명(화면표시용) ==!*/,
        appTpCd: {
            type: "text",
            edit: false,
        } /** Application Type Code !== 신청서_유형_코드 ==! */,
        appTpNm: {
            type: "text",
            label: "L_APP_TP",
            edit: false,
        } /** Application Type Name !== 신청서_유형_코드명 ==! */,
        appNm: { type: "text", label: "L_APP", edit: false } /* Application !== 신청서명(화면표시용) ==!*/,
        sbmtDtm: {
            type: "date",
            label: "L_SBMS_DT",
            edit: false,
        } /* Submission Date !== 제출일자 ==!*/,
        aprvDtm: {
            type: "date",
            label: "L_APRV_DT",
            edit: false,
        } /* Approval Date !== 승인일자 ==!*/,
        appStatCd: {
            type: "text",
            edit: false,
        } /* Status !== 상태 ==!*/,
        appStatNm: {
            type: "text",
            label: "L_STTS",
            edit: false,
        } /* Status !== 상태 ==!*/,
        appXpirDt: {
            type: "date",
            label: "L_VLD_DT",
            edit: false,
        } /* Valid Date !== 유효일자 ==!*/,
        mstrAprvNo: { type: "text", label: "L_MSTR_NO", edit: false } /* Master No. !== 마스터번호 ==!*/,
        amdRsn: { type: "textarea", required: true, edit: false } /* Reason to Amend !== 수정이유 ==!*/,
        nregYn: { type: "text", label: "L_NREG_YN", edit: false } /* Non-Regulated !== 비규제_여부 ==! */,
        tansadNo: {
            label: "L_TANSAD_NO",
            controlSize: 2,
            edit: false,
        } /* TANSAD No !== TANSAD 번호 ==!*/,
        cstmOfceCd: {
            type: "text",
            controlSize: 1,
            only: "control",
            edit: false,
        } /* Customs Office Code !== 세관 사무소 코드 ==! */,
        tansadYy: {
            type: "text",
            controlSize: 1,
            only: "control",
            edit: false,
        } /* TANSAD Year !== TANSAD 년도 ==! */,
        tansadSrno: {
            type: "text",
            controlSize: 1,
            only: "control",
            edit: false,
        } /* TANSAD Serial Number !== TANSAD 일련번호 ==! */,
        feeImpsTpCd: {
            type: "select",
            label: "L_FEE_IMPS",
            area: "comnCd",
            comnCd: "OSC0123",
            edit: false,
        } /* Fee Impose Type Code	!== 수수료 부과 유형 코드 ==! */,
        currCd: {
            type: "select",
            label: "L_CURR_CD",
            area: "comnCd",
            comnCd: "OSC0060",
            edit: false,
        } /* Currency Code	!== 통화 코드 ==! */,
        bllAmt: { type: "number", label: "L_FEE_AMT", edit: false, thousandSeparator: true },
        calcBllAmt: { type: "number", label: "L_BASE_FEE_AMT", edit: false, thousandSeparator: true },
        bllTzsAmt: { type: "number", label: "L_FEE_TZS", edit: false, thousandSeparator: true },
        bllSttsCd: {
            type: "code",
            label: "L_PRCSS_STAT",
            area: "comnCd",
            comnCd: "OSC0122",
            edit: false,
        },
        exrt: { type: "number", label: "L_EXRT", edit: false },
        rmrk: {
            type: "textarea",
            label: "L_RMK",
            rows: 5,
            edit: false,
        } /* Description !== 설명 ==! */,
        prcssRsnCn: {
            type: "textarea",
            label: "L_FEE_RMRK",
            rows: 3,
            edit: false,
        } /* Fee Payment Officer Remarks !== 수수료 담당자 코멘트 ==! */,
    },
};

export const SG_GFS_ITM_LIST: TGridSchema = {
    id: "grid_blldDtlList",
    options: {
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_GFS_CD", binding: "gfsCd", width: "*" }] },
        { cells: [{ header: "L_ITM_NM", binding: "itmNm", width: "2*" }] },
        { cells: [{ header: "L_AMT", binding: "bllItmAmt", width: "*" }] },
        { cells: [{ header: "L_EQV_AMT", binding: "bllItmAmt", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "gfsCd" }] },
        { cells: [{ binding: "itmNm", align: "left" }] },
        { cells: [{ binding: "bllItmAmt", type: "number", thousandSeparator: true, align: "right" }] },
        {
            cells: [{ binding: "bllItmTzsAmt", type: "number", thousandSeparator: true, align: "right" }],
        },
    ],
};

export const SG_BLL_ITM_LIST: TGridSchema = {
    id: "grid_blldDtlList",
    options: {
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_GFS_CD", binding: "gfsCd", width: "*" }] },
        { cells: [{ header: "L_ITM_NM", binding: "itmNm", width: "2*" }] },
        { cells: [{ header: "L_AMT", binding: "bllItmAmt", width: "*" }] },
        { cells: [{ header: "L_EQV_AMT", binding: "bllItmAmt", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "gfsCd" }] },
        { cells: [{ binding: "itmNm", align: "left" }] },
        { cells: [{ binding: "bllItmAmt", type: "number", thousandSeparator: true, align: "right" }] },
        {
            cells: [{ binding: "bllItmTzsAmt", type: "number", thousandSeparator: true, align: "right" }],
        },
    ],
};

// ============================================================
// OSCI0205009Q / 010Q / 011S - 수수료 변경 신청 (Fee Modification Request)
// OSCI_LPCO_FEE_MDFY_R / OSCI_LPCO_FEE_MDFY_ITM_R 기반.
// 기존 OSCI_BLL_REUS_R 기반 처리를 대체 (DB 저장/관리 기능만 해당).
// 기존 REUS 기반 인터페이스 연계(ZMP 전송/확인, /feeAdjust)는 변경하지 않으며,
// 아래 SF_LPCO_FEE_MDFY_DTL의 reusStatCd 등 REUS 참고 필드는 그 목적으로만 남겨둔다.
// ============================================================
export const SF_LPCO_FEE_MDFY_SRCH: TFormSchema = {
    id: "form_lpcoFeeMdfySrch",
    schema: {
        appNo: {
            type: "text",
            label: "L_APP_NO",
            letterCase: "upper",
        },
        ucrNo: { type: "text", label: "L_UCR_NO", letterCase: "upper" },
        bllNo: {
            type: "text",
            label: "L_OGA_BLL_NO",
            letterCase: "upper",
        },
        bllCstmOfceCd: {
            type: "code",
            area: "cstmCd",
            label: "L_CSTM_OFCE",
            edit: false,
        },
        txprTin: {
            type: "text",
            label: "L_TXPR_TIN",
            mask: colUtils.getMaskPattern("tin"),
        },
        mdfyDt: {
            type: "daterange",
            label: "L_RQST_DT",
            start: { name: "mdfyStrtDt" },
            end: { name: "mdfyEndDt" },
            rangeButton: 0,
            controlSize: 10,
        },
        aprvPrcssStatCd: {
            type: "select",
            label: "L_APRV_STAT_CD",
            area: "comnCd",
            comnCd: "OSC0096",
        },
        mdfyStatCd: {
            type: "select",
            label: "L_APRV_STAT_CD",
            area: "comnCd",
            comnCd: "OSC0254",
            all: true,
        },
    },
};

export const SG_LPCO_FEE_MDFY_LIST: TGridSchema = {
    id: "form_lpcoFeeMdfyList",
    options: {
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: "auto",
    },
    head: [
        {
            cells: [
                { header: "L_APP_NO", binding: "appNo", width: "2*" },
                { header: "L_UCR_NO", binding: "ucrNo" },
            ],
            id: "appNo",
        },
        {
            cells: [
                { header: "L_BLL_NO", binding: "bllNo", width: 210 },
                { header: "L_CTRL_NO", binding: "bllDt" },
            ],
            id: "bllNo",
        },
        { cells: [{ header: "L_BLL_DT", binding: "bllDt", width: "*", rowspan: 2 }] },
        {
            cells: [
                { header: "L_MDFY_AMT", binding: "mdfyFeeAmt", width: "*" },
                { header: "L_BLL_AMT", binding: "feeAmt", width: "*" },
            ],
        },
        {
            cells: [
                { header: "L_RQST_DT", binding: "mdfyRqstDt", width: 210 },
                { header: "L_APRV_STAT_CD", binding: "mdfyStatCd" },
            ],
            id: "mdfyStatCd",
        },
    ],
    body: [
        {
            cells: [
                { binding: "appNo", type: "text", align: "left" },
                { binding: "ucrNo", type: "text", align: "left" },
            ],
        },
        {
            cells: [
                { binding: "bllNo", type: "text" },
                { binding: "ctrlNo", type: "text" },
            ],
        },
        { cells: [{ binding: "bllDt", type: "date", rowspan: 2 }] },
        {
            cells: [
                { binding: "mdfyFeeAmt", type: "number", thousandSeparator: true, align: "right" },
                { binding: "feeAmt", type: "number", thousandSeparator: true, align: "right" },
            ],
        },
        {
            cells: [
                { binding: "mdfyRqstDt", type: "date" },
                { binding: "mdfyStatCd", type: "code", area: "comnCd", comnCd: "OSC0254", align: "center" },
            ],
        },
    ],
};
export const SF_LPCO_FEE_MDFY_DTL_SRCH: TFormSchema = {
    id: "form_bllReusDtlSrch",
    schema: {
        srchTp: {
            type: "radio",
            options: [
                { label: "Bill No", value: "B" },
                { label: "TANSAD No", value: "T" },
            ],
            defaultValue: "B",
        },
        bllMgmtId: {
            label: "L_BLL_MGMT_ID",
        },
        bllNo: {
            label: "L_BLL_NO",
        },
        bllSysmCd: {
            type: "text",
            size: 2,
            maxLength: 4,
        },
        bllYy: {
            type: "text",
            size: 1,
            maxLength: 2,
        },
        bllTpCd: {
            type: "text",
            size: 1,
            maxLength: 1,
            letterCase: "upper",
        },
        bllSrno: {
            type: "text",
            size: 3,
            maxLength: 7,
        },
        bllDgr: {
            type: "text",
            size: 1,
            maxLength: 1,
        },
        reffKeyNo: {
            type: "text",
        },
        reffKeyNo1: {
            type: "text",
            size: 2,
            maxLength: 4,
            letterCase: "upper",
            required: true,
        },
        reffKeyNo2: {
            type: "text",
            size: 1,
            maxLength: 2,
            required: true,
        },
        reffKeyNo3: {
            type: "text",
            size: 3,
            maxLength: 7,
            required: true,
        },
    },
};

// 수수료 변경 신청 상세
export const SF_LPCO_FEE_MDFY_DTL: TFormSchema = {
    id: "form_lpcoFeeMdfyDtl",
    schema: {
        bllNo: {
            type: "text",
            label: "L_BLL_NO",
        },
        bllSysmCd: {
            type: "text",
            maxLength: 4,
        },
        bllYy: {
            type: "text",
            maxLength: 2,
        },
        bllTpCd: {
            type: "text",
            maxLength: 1,
        },
        bllSrno: {
            type: "text",
            maxLength: 7,
        },
        bllDgr: {
            type: "text",
            maxLength: 1,
        },
        bllDt: {
            type: "date",
            label: "L_BLL_DT",
        },
        ctrlNo: {
            type: "text",
            label: "L_CTRL_NO",
        },
        zmpDt: {
            type: "date",
            label: "L_ZMP_DT",
        },
        bllTpCdSec: {
            type: "code",
            label: "L_BLL_TP",
            area: "comnCd",
            comnCd: "OSC0058",
        },
        bllStatCd: {
            type: "code",
            label: "L_BLL_STAT",
            area: "comnCd",
            comnCd: "OSC0056",
        },
        pyerMgmtNo: {
            type: "text",
            label: "L_TXPR_TIN",
            mask: colUtils.getMaskPattern("tin"),
        },
        reffKey: {
            type: "text",
        },
        reffKeyTpCd: {
            type: "code",
            area: "comnCd",
            comnCd: "OSC0067",
        },
        bllRgsrId: {
            type: "text",
            label: "L_RGSR",
        },
        currCd: {
            type: "select",
            label: "L_CURR_CD",
            area: "comnCd",
            comnCd: "OSC0060",
            edit: false,
        } /* Currency Code	!== 통화 코드 ==! */,
        feeAmt: {
            type: "number",
            label: "L_FEE_AMT",
            thousandSeparator: true,
            decimalScale: 2,
            align: "right",
        },
        feeTzsAmt: {
            type: "number",
            label: "L_FEE_AMT_TZS",
            thousandSeparator: true,
            decimalScale: 2,
            align: "right",
        },
        payDdlnDt: {
            type: "date",
            label: "L_DDLN_DT",
        },
        lastDdlnXtnsDt: {
            type: "text",
            label: "L_DDLN_XTNS_DT",
        },
        xtnsDt: {
            type: "number",
            label: "L_XTNS_DD",
        },
        lastDdlnXtnsRsn: {
            type: "text",
            label: "L_DDLN_XTNS_RSN",
        },
        mdfyRqstDt: {
            type: "date",
            label: "L_RQST_DT",
        },
        aprvPrcssStatCd: {
            type: "code",
            label: "L_APRV_STAT_CD",
            area: "comnCd",
            comnCd: "OSC0096",
        },
        mdfyStatCd: {
            type: "code",
            label: "L_APRV_STAT_CD",
            area: "comnCd",
            comnCd: "OSC0254",
        },
        mdfyRmrk: {
            type: "text",
            label: "L_RMRK",
        },
    },
};

// 고지 취소 상세 > 고지목록
export const SG_BLL_REUS_DTL_BLL_LIST: TGridSchema = {
    id: "form_bllReusDtlBllList",
    options: {
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_BLL_NO", binding: "bllNo", width: "*" }] },
        { cells: [{ header: "L_BLL_MGMT_ID", binding: "bllMgmtId", width: "*" }] },
        { cells: [{ header: "L_CTRL_NO", binding: "ctrlNo", width: "*" }] },
        { cells: [{ header: "L_BLL_AMT", binding: "feeAmt", width: "*" }] },
        { cells: [{ header: "L_BLL_EQV_AMT", binding: "feeTzsAmt", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "bllNo" }] },
        { cells: [{ binding: "bllMgmtId", mask: colUtils.getMaskPattern("bllNo") }] },
        { cells: [{ binding: "ctrlNo" }] },
        { cells: [{ binding: "feeAmt", type: "number", thousandSeparator: true, align: "right" }] },
        { cells: [{ binding: "feeTzsAmt", type: "number", thousandSeparator: true, align: "right" }] },
    ],
};

// Schema of Bill List Grid !== 고지 목록 그리드 스키마 ==!
export const SG_BLL_REUS_DTL_LIST: TGridSchema = {
    id: "grid_blldDtlList",
    options: {
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: "auto",
    },
    head: [
        { cells: [{ header: "L_BLL_NO", binding: "bllNo", width: 180 }] },
        { cells: [{ header: "L_BLL_MGMT_ID", binding: "bllMgmtId", width: 180 }] },
        { cells: [{ header: "L_BLL_DT", binding: "bllDt", width: 100 }] },
        { cells: [{ header: "L_CTRL_NO", binding: "ctrlNo", width: "*" }] },
        { cells: [{ header: "L_BLL_AMT", binding: "feeAmt", width: "*" }] },
        { cells: [{ header: "L_DUE_DT", binding: "lastPayDdlnDt", width: 100 }] },
    ],
    body: [
        { cells: [{ binding: "bllNo" }] },
        { cells: [{ binding: "bllMgmtId" }] },
        { cells: [{ binding: "bllDt", type: "date" }] },
        { cells: [{ binding: "ctrlNo" }] },
        { cells: [{ binding: "feeAmt", type: "number", thousandSeparator: true, align: "right" }] },
        { cells: [{ binding: "lastPayDdlnDt", type: "date" }] },
    ],
};

// 수수료 변경 신청 등록/수정 폼
export const SF_LPCO_FEE_MDFY: TFormSchema = {
    id: "form_lpcoFeeMdfy",
    schema: {
        mdfyRsnCd: {
            type: "select",
            label: "L_REUS_CD",
            area: "comnCd",
            comnCd: "OSC0203",
            select: true,
            required: true,
        },
        mdfyRmrk: {
            type: "textarea",
            label: "L_RMRK",
            required: true,
            controlSize: 10,
        },
    },
};

export const SG_LPCO_FEE_HIST_LIST: TGridSchema = {
    id: "form_lpcoFeeHistList",
    options: {
        radio: false,
        checkbox: false,
        index: "DESC",
        edit: false,
    },
    head: [
        { cells: [{ header: "L_APRV_PRCSS_DT", binding: "histRgsrDtm", width: 200 }] },
        { cells: [{ header: "L_MDFY_TP", binding: "histTpCd", width: "*" }] },
        { cells: [{ header: "L_BLL_NO", binding: "bllNo", width: "*" }] },
        { cells: [{ header: "L_CTRL_NO", binding: "ctrlNo", width: "*" }] },
        { cells: [{ header: "L_BLL_AMT", binding: "bllAmt", width: "*" }] },
        { cells: [{ header: "L_BLL_XPIR_DT", binding: "bllXpirDt", width: "*" }] },
        { cells: [{ header: "L_APRV_STAT_CD", binding: "feePrcssStatCd", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "histRgsrDtm", type: "datetime" }] },
        {
            cells: [
                {
                    binding: "histTpCd",
                    type: "code",
                    area: "comnCd",
                    comnCd: "OSC0255",
                    viewType: "label",
                    align: "left",
                },
            ],
        },
        { cells: [{ binding: "bllNo", type: "text" }] },
        { cells: [{ binding: "ctrlNo", type: "text" }] },
        { cells: [{ binding: "bllAmt", type: "number", thousandSeparator: true, align: "right" }] },
        { cells: [{ binding: "bllXpirDt", type: "date" }] },
        {
            cells: [
                {
                    binding: "feePrcssStatCd",
                    type: "code",
                    area: "comnCd",
                    comnCd: "OSC0122 ",
                    viewType: "both",
                    align: "center",
                },
            ],
        },
    ],
};
